import find from 'lodash/fp/find';
import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';

import createCloseFormDefaults from './index';
import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';
import translation from '../../../../config/translation';

import { actions as parentActions } from '../../list';

const createCloseForm = ({
	namespace,
	stateNodeName
}) => {
	const closeFormDefaults = createCloseFormDefaults({ namespace, stateNodeName });

	const OPEN = `${namespace}/${stateNodeName}-open-close-form`;
	const CLOSE_SUCCESS = `${namespace}/${stateNodeName}-close-success`;
	const CLOSE_ERROR = `${namespace}/${stateNodeName}-close-error`;

	return {
		...closeFormDefaults,
		initialState: {
			...closeFormDefaults.initialState,
			currentThreadId: null
		},
		actions: {
			...closeFormDefaults.actions,
			closeFormSubmit: formData => (dispatch, getState) => {
				const { closeMessage } = formData;
				const { currentThreadId } = getState()[namespace][stateNodeName];

				dispatch(parentActions.toggleProgressBar());

				const request = http({
					url: endpoints.THREADS.CLOSE.replace('{id}', currentThreadId),
					method: 'put',
					actions: [
						CLOSE_SUCCESS,
						CLOSE_ERROR
					],
					data: {
						closeMessage
					}
				});

				request(dispatch).then(action => {
					if (action.type === CLOSE_SUCCESS) {
						dispatch(closeFormDefaults.actions.toggleCloseForm());
						dispatch(parentActions.fetchData());
					}
				});
			},
			openCloseForm: threadId => dispatch => {
				dispatch({
					type: OPEN,
					payload: threadId
				});
				dispatch(closeFormDefaults.actions.toggleCloseForm());
			}
		},
		reducers: {
			...closeFormDefaults.reducers,
			[OPEN]: (state, action) => ({
				...state,
				[stateNodeName]: {
					...state[stateNodeName],
					currentThreadId: action.payload
				}
			})
		},
		selectors: {
			...closeFormDefaults.selectors,
			getInitialValues: state => {
				if (!state[namespace][stateNodeName]['currentThreadId']) return null;

				const threadListState = state[namespace];
				const { currentThreadId, formInitialValues: { closeMessage } } = threadListState[stateNodeName];
				const getAffiliateLang = flow(find({id: currentThreadId}), get('affiliate_language'));
				const language = getAffiliateLang(threadListState.data);
				const translatedCloseMessage = (translation[closeMessage] && translation[closeMessage][language])
					? translation[closeMessage][language]
					: closeMessage;

				return {
					closeMessage: translatedCloseMessage
				};
			},
			getCloseFormCurrentThreadId: state => state[namespace][stateNodeName]['currentThreadId']
		}
	};
};

export default createCloseForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/close-form/for-thread-list.js